import React, { useEffect, useState, Fragment, useRef } from "react";
import { Helmet } from "react-helmet";
import { useLocation , useNavigate } from "react-router-dom";
import { Class_ETC_Decrypt 
      , Class_ETC_Encrypt
      , Class_ETC_MsgError
      , Class_ETC_MsgSuccess
      , Class_ETC_MsgErrorfocusByID
      , Class_ETC_Warning
      , Class_ETC_Warning_actionYesandNo_NodidClose
      , Class_ETC_SessionTimeOut
      ,HtmlTooltip
    } from "../Class/Class_Etc";
import Pathurl from "../Class/Pathurl.json";
import MsgDescription from "../Class/MsgDescription.json";
import ConfigETC from "../Class/ConfigETC.json";
import "react-datepicker/dist/react-datepicker.css"
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PaginationActions from "../PartialView/PaginationActions"
import CurrencyInput from 'react-currency-input-field';
import { CP_CheckPermission } from "../Class/Class_Permission"

import DeptSettingView from "../PartialView/DeptSetting_View.js"
import DeptSettingEdittableRow from "../PartialView/DeptSetting_EdittableRow.js"
import SelectStaffForPos from "../Library/Select_StaffForPos.js";
import SelectProject from "../Library/Select_Project.js";

import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';

/* Create By Poom : 17-05-2023 
   Update By Pratan : 23-04-2024 - ปรับ DDL stafff ให้เป็นแบบเลือกได้หลายชื่อ แล้วก็ให้บันทึกคนที่เลือกพร้อมกันได้เลย 
   Update By Pratan : 23-04-2024 - ปรับให้สามารถเลือกได้ว่าจะ copy project organization หรือไม่
   Update By POOM : 03/05/2024  
    - เพิ่มการแสดงข้อมูลและบันทึก Rate ราคา PER DIEM  ต่อวัน   (baht/day) , Rate ราคา travel ต่อกิโลเมตร   (baht/km)

  Edit BY POOM : 09-05-2024 
    - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
  
  Edit By POOM : 2024-05-13  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที



*/
function M_project_ae() {

  //#region ประกาศตัวแปร
  
  //#region ############# ส่วนของ setting #############
  const navigate = useNavigate();
  const location = useLocation();
  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  const isService_department = CP_CheckPermission("service_list",["department"],false,false);
  const [pgAct, setPgAct] = useState("");
  const [pgProid, setPgProid] = useState(-1);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [ ActEdit ] = useState(Class_ETC_Encrypt("Edit"));
  const [ ActAdd ] = useState(Class_ETC_Encrypt("Add"));

  const [isPermissionEdit, setIsPermissionEdit] = useState(false);
  const [isPermissionDel, setIsPermissionDel] = useState(false);
  const [isPermissionAdd, setIsPermissionAdd] = useState(false);
  //#endregion

  //#region ############# * ส่วนของ Project กล่องแรก #############
  const [listcus, setListcus] = useState([]);
  const [dataproae_cusid, setDataproae_cusid] = useState("");
  const [listcus_inactive, setListcus_inactive] = useState([]);
  // const [startDate, setStartDate] = useState(null); //useState(new Date());
  // const [endDate, setEndDate] = useState(null);

  const [dataproae_pro_status , setDataproae_pro_status] = useState(true);
  //#endregion

  //#region ############# ส่วนของ paging #############
  const [pagepod, setPagepod] = useState(0);
  const [rowsPerPagepod] = useState(ConfigETC.rowsPerPage); 
  const handleChangePagepod = (event, newPage) => {
    setPagepod(newPage);
  };
  const handleChangeRowsPerPagepod = (event) => {
    setPagepod(0);
  };

  const [pagepos, setPagepos] = useState(0);
  const [rowsPerPagepos] = useState(ConfigETC.rowsPerPage); 
  const handleChangePagepos = (event, newPage) => {
    setPagepos(newPage);
  };
  const handleChangeRowsPerPagepos = (event) => {
    setPagepos(0);
  };

  const [pagepop, setPagepop] = useState(0);
  const [rowsPerPagepop] = useState(ConfigETC.rowsPerPage); 
  const handleChangePagepop = (event, newPage) => {
    setPagepop(newPage);
  };
  const handleChangeRowsPerPagepop = (event) => {
    setPagepop(0);
  };
  //#endregion

  //#region ############# * ส่วนของ Project กล่อง Org ############# */
  const [isbindPodfirst, setIsbindPodfirst] = useState(false);
  const [listddldept, setListddldept] = useState([]);
  const [listpod_getcount, setListpod_getcount] = useState([]);
  const [listcopypos, setListcopypos] = useState([]);
  // eslint-disable-next-line
  const [cn_divbox2_right_dept, setCn_divbox2_right_dept] = useState("tab-pane fade");
  const [cn_divbox2_right_staff, setCn_divbox2_right_staff] = useState("tab-pane fade");
  const [pod_actAE, setPod_actAE] = useState("Add");
  const [pod_ProdeptidEdit, setPod_ProdeptidEdit] = useState(0);

  const [listpos_getlist, setListpos_getlist] = useState([]);
  // const [listddl_staff, setListddl_staff] = useState([]);
  const [ddl_AddStaff , setDdl_AddStaff] = useState(null);

  const selectRef_Staff = useRef(null)

  const [listddl_positiondept, setListddl_positiondept] = useState([]);
  const [listddl_positiondeptMove, setListddl_positiondeptMove] = useState([]);
  const [ismorepositionshow, setIsmorepositionshow] = useState(true);
  const [ismorepositionshowMove, setIsmorepositionshowMove] = useState(true);
  
  const [listpop_getlist, setListpop_getlist] = useState([]);
  const [data_model_position_pos_rate_WT, setData_model_position_pos_rate_WT] = useState(0.00);
  const [data_model_position_pos_rate_OT, setData_model_position_pos_rate_OT] = useState(0.00);

  
  const [data_model_position_pos_rate_exp_extra, setData_model_position_pos_rate_exp_extra] = useState(0.00);
  const [data_model_position_pos_rate_exp_travel, setData_model_position_pos_rate_exp_travel] = useState(0.00);

  const [data_model_position_TS, setData_model_position_TS] = useState("0");
  const [data_model_position_TO, setData_model_position_TO] = useState("0");
  const [data_model_position_PM, setData_model_position_PM] = useState("0");

  //#endregion


  //#region ############# * ส่วนของ Department setting #############
  const [editDeptSettingId, setEditDeptSettingId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    dept_name: "",
    pro_dept_id: 0,
  });
  const [a_box2left_dept, setA_box2left_dept] = useState("");
  const [a_box2left_dept_sorting, setA_box2left_dept_sorting] = useState("");
  const [isSorting, setIsSorting] = useState(null);
  const [isClick, setIsClick] = useState(false);
  
  const [a_box2left_dept_name, setA_box2left_dept_name] = useState("");

  let deptCount = 1;

  //#endregion

  const [searchProjectOrg, setSearchProjectOrg] = useState(null);

  const [iscntreset, setIscntreset] = useState(0);
  const [iscntrebind, setIscntrebind] = useState(0);
  const selectRef_PorjectOrg = useRef(null)
  const modalRef = useRef();


  //#region ############# * ส่วนของ Copy ProjectOrg setting #############
  
  //#endregion

  //#endregion

  //#region __ useEffect __
  useEffect(() => {
    if (isFirst === true) {
      GetParameter(function() {
        if (pgAct !== "")
        {
          
          let isPerView = CP_CheckPermission("main" , ["projects_view"] , false , true);
          if (isPerView)
          {
            let isPerAdd = false; 
            let isPerEdit = false;

            if(pgAct === "Add" )
            {
              isPerAdd = CP_CheckPermission("main" , ["projects_add"] , false , true);
            }
            else
            {
              isPerEdit = CP_CheckPermission("main" , ["projects_edit"] , false , false);
            }

            setIsPermissionEdit(isPerEdit);
            setIsPermissionDel(CP_CheckPermission("main" , ["projects_delete"] , false , false))
            setIsPermissionAdd(isPerAdd);

            GetConfig();
            if (isLoadedConfigData === true) {
              BindDDLDepartment(function() {
                BindCustomer(function (){
                    if (pgAct === "Add") {
                      setDataproae_cusid("-1");
                      setIsLoadProgress(false);
                    } else {
                      setIsLoadProgress(true);
                      BindProject(function () {
                        // Bindddl_staff(function() {
                          BindProOrg_Department_Getcount(false , function (){
                            setIsbindPodfirst(true);
                            //setIsLoadProgress(false);
                          });
                        // });
                      });
                    }
                    setIsFirst(false);
                });
              });
            }

          }


        }
      });
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData , pgAct]);

  useEffect(() => {
    if (isbindPodfirst === true) {
      if (listpod_getcount.length > 0)
      {
        onclick_pod_cl_right_staff(listpod_getcount[0].rowindex , listpod_getcount[0].pro_dept_id , listpod_getcount[0].dept_name)
      }
      else
      {
        setIsLoadProgress(false);
      }
      setIsbindPodfirst(false);
    }
    // eslint-disable-next-line
  }, [listpod_getcount]);

 

  //#endregion

  //#region __ Box ส่วนบน Project __
  function GetParameter(_callback) {
    let isNullParameter = false;
    let proid = "";
    let act = "";

    try {
      if (location.state === null) {
        isNullParameter = true;
      } else {
        proid = Class_ETC_Decrypt(location.state?.proid.toString());
        act = Class_ETC_Decrypt(location.state?.act.toString());

        if (act === "") {
          isNullParameter = true;
        } else if (act !== "Add" && act !== "Edit") {
          isNullParameter = true;
        } else {
          if (act === "Edit" && proid === "") {
            isNullParameter = true;
          }
        }
      }
    } catch {
      isNullParameter = true;
    }

    if (isNullParameter) {
      window.location.replace("../" + Pathurl.m_projectSearch);
      if (_callback != null) {
          _callback();
      }
    } else {
      setPgAct(act);
      setPgProid(proid);
      if (_callback != null) {
          _callback();
      }
    }
  }

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  async function BindCustomer(_callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        cus_status: "1",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Customer_Getlist",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          const arr = [];
          json.data.map((en) => {
            return arr.push({
              value: en.cus_id.toString(),
              label: en.cus_name,
            });
          });
          setListcus(arr);
          if (_callback != null) {
              _callback();
          }
        } else {
          setListcus([]);
          if (_callback != null) {
              _callback();
          }
        }
      }
      else {
        setListcus([]);
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setListcus([]);
      if (_callback != null) {
          _callback();
      }
    }
  }

  async function BindProject(_callback) {

    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pro_id: pgProid.toString(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_GetData",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          if (json.m_cus_id !== -1) {
            setListcus_inactive([
              { value: json.m_cus_id, label: json.m_cus_name },
            ]);
          }
          
          document.getElementById("txt_proAE_pro_name").value = json.pro_name;
          document.getElementById("txt_proAE_pro_desc").value = json.pro_desc;

          document.getElementById("txt_proAE_pro_start_date").value = json.pro_start_date
          document.getElementById("txt_proAE_pro_end_date").value = json.pro_end_date

          setDataproae_pro_status(json.pro_status === 1 ? true : false);
          setDataproae_cusid(json.cus_id.toString());
          
          if (_callback != null) {
              _callback();
          }
        } else {
          window.location.replace("../" + Pathurl.m_projectSearch);
        }
      } 
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        window.location.replace("../" + Pathurl.m_projectSearch);
      }
    } catch {
      window.location.replace("../" + Pathurl.m_projectSearch);
    }
  }

  function onclickSaveProAE(){
    
    setIsLoadProgress(true);
    var istxtError = "";


    if (document.getElementById("txt_proAE_pro_name").value.trim() === "")
    {
      istxtError = "txt_proAE_pro_name";
    }
    else if (document.getElementById("ddl_proAE_cus_id").value.trim() === "-1")
    {
      istxtError = "ddl_proAE_cus_id";
    }


    if (istxtError !== "")
    {
      setIsLoadProgress(false);
      Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001 , istxtError);
    }
    else
    {
      if(pgAct === "Add")
      {
        setIsLoadProgress(false);
        Class_ETC_Warning_actionYesandNo_NodidClose(MsgDescription.CFM005 , onclick_CopyProjectOrg , SaveProAE);
      }
      else
      {
        SaveProAE();
      }
    }
  }

  

  async function SaveProAE()
  {
    setIsLoadProgress(true);
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      
      let SD = document.getElementById("txt_proAE_pro_start_date").value.trim()
      let ED = document.getElementById("txt_proAE_pro_end_date").value.trim()
      let pn = document.getElementById("txt_proAE_pro_name").value.trim();
      let cid = document.getElementById("ddl_proAE_cus_id").value.trim();
      let py = "";
      let pt = "";
      let pic = "0";
      let ps = (dataproae_pro_status === true ? "1" : "0");
      let pd = document.getElementById("txt_proAE_pro_desc").value.trim();


      var raw;
      

      if (pgAct === "Add")
      {
        raw = JSON.stringify({
          "pro_name": pn,
          "cus_id": cid,
          "pro_year": py,
          "pro_type": pt,
          "pro_start_date": SD,
          "pro_end_date": ED,
          "pro_is_close": pic,
          "pro_status": ps,
          "pro_desc": pd
        });
      }
      else
      {
        raw = JSON.stringify({
          "pro_id": pgProid,
          "pro_name": pn,
          "cus_id": cid,
          "pro_year": py,
          "pro_type": pt,
          "pro_start_date": SD,
          "pro_end_date": ED,
          "pro_is_close": pic,
          "pro_status": ps,
          "pro_desc": pd
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + (pgAct === "Add" ? "Project_Add" : "Project_Edit"),
        requestOptions
      );
      const json = await response.json();

      if (json.status_ID === 1) {
        setIsLoadProgress(false);
        if (pgAct === "Add")
        {
          document.getElementById("hd_Proid_Edit").value = json.pro_id.toString();
          Class_ETC_MsgSuccess(MsgDescription.CFM001, GotoProject);
        }
        else
        {
          setIsLoadProgress(true);
          BindProject(function () {
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM001 , null);
          });
          
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }

  }



  function GotoProject(){
    navigate( "../" + Pathurl.m_project_ae, { state: {
        proid: Class_ETC_Encrypt(document.getElementById("hd_Proid_Edit").value.trim()),act: ActEdit
      } 
    }); 
    window.location.reload()
  }

  function onclick_Cancel(){
    navigate( "../" + Pathurl.m_project_ae, { state: {
      proid: Class_ETC_Encrypt(pgProid.toString()),
      act: (pgAct === "Add" ? ActAdd : ActEdit)
      } 
    }); 
    window.location.reload()
  }
  
  function OnChangevalueStaff(e){
    setDdl_AddStaff(e)
  }
  

  // async function Bindddl_staff(_callback) {
  //   try {
  //     let token = "";
  //     token = localStorage.getItem("TStoken");
  //     var myHeaders = new Headers();
  //     myHeaders.append("Authorization", "Bearer " + token);
  //     myHeaders.append("Content-Type", "application/json");
  //     var raw = JSON.stringify({
  //       "pro_id": pgProid.toString()
  //     });

  //     var requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow",
  //     };

  //     const response = await fetch(
  //       configData.API_URL + "ProjectOrgStaff_Getddl",
  //       requestOptions
  //     );

  //     const json = await response.json();
  //     if (json.status_ID === 1) {
  //       if (json.total_Data > 0) {
  //         setListddl_staff(json.data);
  //         if (_callback != null) {
  //             _callback();
  //         }
  //       } else {
  //         setListddl_staff([]);
  //         if (_callback != null) {
  //             _callback();
  //         }
  //       }
  //     }
  //   } catch {
  //     setListddl_staff([]);
  //     if (_callback != null) {
  //         _callback();
  //     }
  //   }
  // }

  //#endregion

  //#region __ Box ส่วนล่าง Organization __

  //#region __ ProjectOrg_Department __

  async function BindDDLDepartment(_callback){

    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        dept_status: "1",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Department_Get",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListddldept(json.data);
          if (_callback != null) {
              _callback();
          }
        } else {
          setListddldept([]);
          if (_callback != null) {
              _callback();
          }
        }
      }
      else {
        setListddldept([]);
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setListddldept([]);
      if (_callback != null) {
          _callback();
      }
    }

  }

  async function BindProOrg_Department_Getcount(isDel = false  , _callback)
  {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pro_id: pgProid.toString(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgDepartment_Getcount",
        requestOptions
      );
      const json = await response.json();

      if (json.status_ID === 1) {
        if (json.total_Data > 0) {

          if (isDel) {
            if (rowsPerPagepod * (pagepod + 1) > json.total_Data) {
              let pagenow = Math.ceil(json.total_Data / rowsPerPagepod);
              setPagepod(pagenow === 0 ? 0 : pagenow - 1);
            }
          }

          setListpod_getcount(json.data);
          if (_callback != null) {
              _callback();
          }
        } else {
          setPagepod(0);
          setListpod_getcount([]);
          if (_callback != null) {
              _callback();
          }
        }
      }
      else {
        setPagepod(0);
        setListpod_getcount([]);
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setPagepod(0);
      setListpod_getcount([]);
      if (_callback != null) {
          _callback();
      }
    }
  }

  function loopclearactive_box2left(_callback){

    // document.getElementById("a_box2left_deptsetting").className = "nav-link";
    for (let i = 0 ; i < listpod_getcount.length; i ++)
    {
      try  { document.getElementById("a_box2left_dept_" + (i+1)).className = "nav-link"; }
      catch {  }
    }
    if (_callback != null) {
        _callback();
    }
  }

  function onclick_pod_cl_right_dept(){
    setEditDeptSettingId(null);
    // loopclearactive_box2left(function () {
    //   setCn_divbox2_right_staff("tab-pane fade");
    //   setCn_divbox2_right_dept("tab-pane text-left fade show active");
    //   document.getElementById("a_box2left_deptsetting").className = "nav-link active";
    // });

  }

  function onclick_pod_cl_right_staff(rowindex , pro_dept_id , dept_name){
    document.getElementById("hd_box2_pro_dept_id").value = pro_dept_id;
    document.getElementById("hd_box2_pro_dept_name").value = dept_name;
    setIsLoadProgress(true);
    loopclearactive_box2left(function () {
      box2_OpenCloseStaffPosition("staff");
      setCn_divbox2_right_dept("tab-pane fade");
      setCn_divbox2_right_staff("tab-pane text-left fade show active");
      setA_box2left_dept(pro_dept_id);
      setA_box2left_dept_name(dept_name);
      setIsSorting(false)
      setIsClick(true)
      document.getElementById("a_box2left_dept_" + rowindex.toString()).className = "nav-link active";
      BindProOrg_Staff_Getlist("new" , function () {
        //BindProOrgPosition_Getlist("new" , function() {
          setIsLoadProgress(false);
        //});
      });
    });
  }

  function onclick_PODAdd() {
    setPod_actAE("Add");
    ProDept_AE_Display("Add")
    document.getElementById("ddl_deptAdd_pro_dept_id").value = "-1";
  }

  function onclick_PODEdit(event,pro_dept_id , dept_name ) {
    setIsLoadProgress(true)
    event.preventDefault();


    setPod_actAE("Edit");
    ProDept_AE_Display("Edit")
    setPod_ProdeptidEdit(pro_dept_id);
    // document.getElementById("txt_deptEdit_dept_name").value = dept_name;

    setEditDeptSettingId(pro_dept_id);

    const formValues = {
      dept_name: dept_name,
      pro_dept_id: pro_dept_id,
     
    };

    setEditFormData(formValues);
    setIsLoadProgress(false)

  }

  function onclick_PODDel(pro_dept_id) {
    document.getElementById("hd_PODdel").value = pro_dept_id;
    Class_ETC_Warning(MsgDescription.CFM002, SavedepartmentDel);

  }

  function ProDept_AE_Display(act){

    if (act === "Add")
    {
      document.getElementById("txt_deptEdit_dept_name").style.display = "none";
      document.getElementById("ddl_deptAdd_pro_dept_id").style.display = "block";
    }
    else
    {
      document.getElementById("txt_deptEdit_dept_name").style.display = "block";
      document.getElementById("ddl_deptAdd_pro_dept_id").style.display = "none";
    }

  }

  function OnclickCancel_ModeldepartmentAE() {
    setEditDeptSettingId(null);
  };

  function OnclickSave_ModeldepartmentAE(){

    setIsLoadProgress(true);

    var istxtError = "";
    if (pod_actAE === "Add")
    {
      if (document.getElementById("ddl_deptAdd_pro_dept_id").value.trim() === "-1")
      {
        istxtError = "ddl_deptAdd_pro_dept_id";
      }
    }
    else{
      // if (document.getElementById("txt_deptEdit_dept_name").value.trim() === "")
      if (document.getElementById("txt_dept_name_setting_Edit").value.trim() === "")
      {
        // istxtError = "txt_deptEdit_dept_name";
        istxtError = "txt_dept_name_setting_Edit";
      }
    }

    if (istxtError !== "")
    {
      setIsLoadProgress(false);
      Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001 , istxtError);
    }
    else
    {
      SavedepartmentAE();
    }
  }

  async function SavedepartmentAE(){
    
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      
     
      var raw;

      if (pod_actAE === "Add")
      {
        let ddl_addpdi = document.getElementById("ddl_deptAdd_pro_dept_id").value.trim();
        raw = JSON.stringify({
          "pro_id": pgProid ,
          "dept_id": ddl_addpdi
        });
      }
      else
      {
        // let dept_name = document.getElementById("txt_deptEdit_dept_name").value.trim();
        let dept_name = document.getElementById("txt_dept_name_setting_Edit").value.trim();
        raw = JSON.stringify({
          "pro_id": pgProid ,
          "dept_id": pod_ProdeptidEdit.toString(),
          "dept_name": dept_name
        });
      }

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + (pod_actAE === "Add" ? "ProjectOrgDepartment_Add" : "ProjectOrgDepartment_Edit"),
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        BindProOrg_Department_Getcount(false ,function () {

          if(pod_ProdeptidEdit.toString() === a_box2left_dept.toString()){
            setA_box2left_dept_name(document.getElementById("txt_dept_name_setting_Edit").value.trim());
          }

          document.getElementById("modaldept_Close").click();
          setEditDeptSettingId(null);
          setIsLoadProgress(false);
          Class_ETC_MsgSuccess(MsgDescription.CFM001 , null);
        });
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }
  }

  async function SavedepartmentDel(){
    
    try {
      setIsLoadProgress(true);
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      let pro_dept_id = document.getElementById("hd_PODdel").value.trim();
      var raw;
      raw = JSON.stringify({
        "pro_id": pgProid ,
        "pro_dept_id": pro_dept_id
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgDepartment_Del",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        BindProOrg_Department_Getcount(true , function () {
          setIsLoadProgress(false);

          if(pro_dept_id.toString() === a_box2left_dept.toString()){
            document.getElementById("a_box2left_dept_1").className = "nav-link active";
            document.getElementById("a_box2left_dept_1").click();
          }

          Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
        });
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR003, null);
    }
  }

  async function onclick_PODSorting(pro_dept_id , act){
    
    try {
      setIsLoadProgress(true);
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw;
      raw = JSON.stringify({
        "pro_id": pgProid ,
        "pro_dept_id": pro_dept_id.toString(),
        "act": act
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgDepartment_Sorting",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        BindProOrg_Department_Getcount(false , function () {
          if(isClick === false){
            loopclearactive_box2left(function(){
              setIsSorting(true)
              setA_box2left_dept_sorting(pro_dept_id);
            })
          }
        });
        setIsLoadProgress(false);

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }
  }

  //#endregion

  //#region __ ProjectOrg_Staff __
  
  async function BindProOrg_Staff_Getlist(actpage = "" ,_callback)
  {
    let pdid = document.getElementById("hd_box2_pro_dept_id").value.trim();

    try {
      setListpos_getlist([]);
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "pro_id": pgProid.toString(),
        "pro_dept_id": pdid
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };


      const response = await fetch(
        configData.API_URL + "ProjectOrgStaff_Getlist",
        requestOptions
      );
      const json = await response.json();

      if (json.status_ID === 1) {
        if (json.total_Data > 0) {

          if (actpage === "new") {
            setPagepos(0);
          } 
          else if (actpage === "check") {
            if (rowsPerPagepos * (pagepos + 1) > json.total_Data) {
              let pagenow = Math.ceil(json.total_Data / rowsPerPagepos);
              setPagepos(pagenow === 0 ? 0 : pagenow - 1);
            }
          }

          setListpos_getlist(json.data);
          BindDDLPositionDept(pdid , "0" , "" ,function() {
            if (_callback != null) {
                _callback();
            }
          });
        } else {
          setPagepos(0);
          setListpos_getlist([]);
          BindDDLPositionDept(pdid , "0" , "" ,function() {
            if (_callback != null) {
                _callback();
            }
          });
        }
      }
      else
      {
        setPagepos(0);
        setListpos_getlist([]);
        BindDDLPositionDept(pdid , "0" , "" ,function() {
          if (_callback != null) {
              _callback();
          }
        });
      }
    } catch {
      setPagepos(0);
      setListpos_getlist([]);
      BindDDLPositionDept(pdid , "0" , "" ,function() {
        if (_callback != null) {
            _callback();
        }
      });
    }
  }
  
  async function BindDDLPositionDept(pro_dept_id , selectmaster , actlist , _callback)
  {
    try {
      selectmaster = "1";
      let token = ""; 
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "pro_id": pgProid.toString(),
        "pro_dept_id": pro_dept_id,
        "selectmaster": selectmaster
      }); 

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgPosition_Getddl",
        requestOptions
      );
      const json = await response.json();
      
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          
          if (actlist === "move")
          {
            setListddl_positiondeptMove(json.data);
            setIsmorepositionshowMove((selectmaster === "0" ? true : false))
          }
          else
          {
            setListddl_positiondept(json.data);
            setIsmorepositionshow((selectmaster === "0" ? true : false))
          }
          if (_callback != null) {
              _callback();
          }
        } else {
          
          if (actlist === "move")
          {
            setListddl_positiondeptMove([]);
            setIsmorepositionshowMove(true)
          }
          else
          {
            setListddl_positiondept([]);
            setIsmorepositionshow(true)
          }
          if (_callback != null) {
              _callback();
          }
        }
      }
      else
      {
        if (actlist === "move")
        {
          setListddl_positiondeptMove([]);
          setIsmorepositionshowMove(true)
        }
        else
        {
          setListddl_positiondept([]);
          setIsmorepositionshow(true)
        }
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      if (actlist === "move")
      {
        setListddl_positiondeptMove([]);
        setIsmorepositionshowMove(true)
      }
      else
      {
        setListddl_positiondept([]);
        setIsmorepositionshow(true)
      }
      if (_callback != null) {
          _callback();
      }
    }
  }

  async function onclick_POSEdit(event , staff_code) {

    setIsLoadProgress(true);
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

     
      var raw;
      raw = JSON.stringify({
          "pro_id": pgProid ,
          "pro_dept_id": document.getElementById("hd_box2_pro_dept_id").value,
          "staff_code": staff_code,
          "staff_status": (event.target.checked === true ? "1" : "0")
      });
      
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgStaff_Edit",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        BindProOrg_Staff_Getlist("" ,function () {
          setIsLoadProgress(false);
          Class_ETC_MsgSuccess(MsgDescription.CFM001 , null);
        });
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }
  }

  function onchange_ddl_box2s_positionstaff(event){

    let ddl = document.getElementById("ddl_box2s_positionstaff").value
    if (ddl === "-99")
    {
      let pro_dept_id = document.getElementById("hd_box2_pro_dept_id").value
      setIsLoadProgress(true);
      BindDDLPositionDept(pro_dept_id , "1"  , "" , function () {
        setIsLoadProgress(false);
      });
      
    }
  }

  function onclick_POS_SaveAdd(){
    setIsLoadProgress(true);
    var isError = "";
    var txtError = "";

    // if (document.getElementById("ddl_box2s_staff").value.trim() === "-1")
    // {
    //   txtError = "ddl_box2s_staff";
    // }
    if (ddl_AddStaff === null)
    {
      txtError = "ddl_box2s_staff";
    }
    else if (ddl_AddStaff !== null)
    {
        if (ddl_AddStaff.length === 0)
        {
          txtError = "ddl_box2s_staff";
        }
    }
    
    if (document.getElementById("ddl_box2s_positionstaff").value.trim() === "-1")
    {
      txtError = "ddl_box2s_positionstaff";
    }
    else
    {
      let ddlps = document.getElementById("ddl_box2s_positionstaff").value.trim();
      let arrddlps = ddlps.split("|");
      if (arrddlps.length === 2)
      {
          if (arrddlps[1] !== "p" && arrddlps[1] !== "m")
          {
            isError = "position";
            txtError = "ddl_box2s_positionstaff";
          }
      }
      else
      {
        isError = "position";
        txtError = "ddl_box2s_positionstaff";
      }
    }


    if (txtError !== "")
    {
      if (txtError === "ddl_box2s_staff")
      {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR001 , SelectFocas_ddlStaff);
      }
      else
      {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID((isError === "position" ? MsgDescription.ERR012 : MsgDescription.ERR001) , txtError);
      }
    }
    else
    {
      SavedSaffAdd();
    }
  }

  function SelectFocas_ddlStaff(){
    selectRef_Staff.current?.focus()
  }
  
  async function SavedSaffAdd()
  {
    
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

     
      var raw;
      let dept_id = document.getElementById("hd_box2_pro_dept_id").value.trim();
      let ddlps = document.getElementById("ddl_box2s_positionstaff").value.trim();
      let arrddlps = ddlps.split("|");
      let pid = (arrddlps.length === 2 ? arrddlps[0] : "");
      let ptype = (arrddlps.length === 2 ? arrddlps[1] : "");
      // let staff_code = document.getElementById("ddl_box2s_staff").value.trim();
      let staff_code = "";

      if (ddl_AddStaff !== null) {
        staff_code = "";
        if (ddl_AddStaff.length > 0) {
            for (let i = 0; i < ddl_AddStaff.length; i++) {
              staff_code = staff_code + (staff_code === "" ? "" : ",") + ddl_AddStaff[i].value;
            }
        }
    }

      raw = JSON.stringify({
        "pro_id": pgProid ,
        "pro_dept_id": dept_id,
        "pos_id": pid,
        "pos_type": ptype,
        "staff_code": staff_code
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgStaff_Add",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        
        BindProOrg_Department_Getcount(false ,function () {
          BindProOrg_Staff_Getlist("" , function () {
            // Bindddl_staff(function() {
              document.getElementById("ddl_box2s_positionstaff").value = "-1";
              // document.getElementById("ddl_box2s_staff").value = "-1";
              document.getElementById("modalStaffAdd_Close").click();
              setIscntreset((iscntreset) => iscntreset + 1)
              setIscntrebind((iscntrebind) => iscntrebind + 1)
              setIsLoadProgress(false);
              Class_ETC_MsgSuccess(MsgDescription.CFM001 , null);
            // });
          });
        });

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }

  }

  function onclick_POS_SaveDel(staff_code){
    document.getElementById("hd_POSdel").value = staff_code;
    Class_ETC_Warning(MsgDescription.CFM002, SavedStaffDel);
  }

  async function SavedStaffDel(){
    
    try {
      setIsLoadProgress(true);

      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
     
      var raw;
      raw = JSON.stringify({
        "pro_id": pgProid ,
        "staff_code": document.getElementById("hd_POSdel").value.trim(),
        "pro_dept_id": document.getElementById("hd_box2_pro_dept_id").value.trim()
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgStaff_Del",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {

        
        BindProOrg_Department_Getcount(false ,function () {
          BindProOrg_Staff_Getlist("check" , function () {
            // Bindddl_staff(function() {
              document.getElementById("ddl_box2s_positionstaff").value = "-1";
              setIscntreset((iscntreset) => iscntreset + 1)
              setIscntrebind((iscntrebind) => iscntrebind + 1)
              // document.getElementById("ddl_box2s_staff").value = "-1";
              setIsLoadProgress(false);
              Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
            // });
          });
        });

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      } 
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR003, null);
    }

  }

  function onclick_POS_Move(position_name , staff_code , staff_fullname){

    document.getElementById("lbl_model_move_staff_FullName").innerHTML = staff_fullname;
    document.getElementById("lbl_model_move_staff_DeptName").innerHTML = document.getElementById("hd_box2_pro_dept_name").value;
    document.getElementById("lbl_model_move_staff_Position_Name").innerHTML = position_name;
    document.getElementById("hd_model_move_staff_staffcode").value = staff_code;

    if (isService_department === true)
    {
      document.getElementById("ddl_model_move_staff_dept").value = "-1";
      document.getElementById("ddl_model_move_staff_position").disabled = false;

      document.getElementById("ddl_model_move_staff_position").value = "-1";
      document.getElementById("ddl_model_move_staff_position").disabled = true;
    }
    else{
      
      /* ถ้าไม่มี Service  จะให้ dept ห้ามเลือก */
      document.getElementById("ddl_model_move_staff_dept").value = document.getElementById("hd_box2_pro_dept_id").value;
      document.getElementById("ddl_model_move_staff_dept").disabled = true;
      
      onchange_ddl_model_move_staff_dept();
    }

    setIsmorepositionshowMove(true);
    setListddl_positiondeptMove([]);

  }
  
  function onchange_ddl_model_move_staff_dept(){
    
    let ddl = document.getElementById("ddl_model_move_staff_dept").value
    if (ddl === "-1")
    {
      document.getElementById("ddl_model_move_staff_position").disabled = true;
    }
    else
    {
      setIsLoadProgress(true);
      BindDDLPositionDept(ddl , "0"  , "move" , function () {
          setIsLoadProgress(false);
          document.getElementById("ddl_model_move_staff_position").disabled = false;
      });
    }
    
  }

  function onchange_ddl_model_move_staff_position(){
    
    let ddl = document.getElementById("ddl_model_move_staff_position").value
    if (ddl === "-99")
    {
      let pro_dept_id = document.getElementById("ddl_model_move_staff_dept").value
      setIsLoadProgress(true);
      BindDDLPositionDept(pro_dept_id , "1"  , "move" , function () {
        setIsLoadProgress(false);
      });
    }
  }

  function onclick_POS_MoveSave(){

    
    setIsLoadProgress(true);
    var isError = "";
    var txtError = "";

    if (document.getElementById("ddl_model_move_staff_dept").value.trim() === "-1")
    {
      txtError = "ddl_model_move_staff_dept";
    }
    else if (document.getElementById("ddl_model_move_staff_position").value.trim() === "-1")
    {
      txtError = "ddl_model_move_staff_position";
    }
    else
    {
      let ddlps = document.getElementById("ddl_model_move_staff_position").value.trim();
      let arrddlps = ddlps.split("|");
      if (arrddlps.length === 2)
      {
          if (arrddlps[1] !== "p" && arrddlps[1] !== "m")
          {
            isError = "position";
            txtError = "ddl_model_move_staff_position";
          }
      }
      else
      {
        isError = "position";
        txtError = "ddl_model_move_staff_position";
      }
    }
   

    if (txtError !== "")
    {
      setIsLoadProgress(false);
      Class_ETC_MsgErrorfocusByID((isError === "position" ? MsgDescription.ERR012 : MsgDescription.ERR001) , txtError);
    }
    else
    {
      SavedSaffMove();
    }
  }

  async function SavedSaffMove(){

    
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

     
      var raw;
      let dept_id = document.getElementById("hd_box2_pro_dept_id").value.trim();
      let ddlps = document.getElementById("ddl_model_move_staff_position").value.trim();
      let arrddlps = ddlps.split("|");
      let pid = (arrddlps.length === 2 ? arrddlps[0] : "");
      let ptype = (arrddlps.length === 2 ? arrddlps[1] : "");
      let staff_code = document.getElementById("hd_model_move_staff_staffcode").value.trim();
      let dept_id_to = document.getElementById("ddl_model_move_staff_dept").value.trim();

      raw = JSON.stringify({
        "pro_id": pgProid ,
        "staff_code": staff_code,
        "pro_dept_id_from": dept_id,
        "pro_dept_id_to": dept_id_to,
        "pro_pos_id_to": pid,
        "pos_type_to": ptype
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgStaff_Move",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        
        BindProOrg_Department_Getcount(false ,function () {
          BindProOrg_Staff_Getlist("check" , function () {
            // Bindddl_staff(function() {
              document.getElementById("ddl_box2s_positionstaff").value = "-1";
              setIscntreset((iscntreset) => iscntreset + 1)
              setIscntrebind((iscntrebind) => iscntrebind + 1)
              // document.getElementById("ddl_box2s_staff").value = "-1";
              document.getElementById("modalmovestaff_Close").click();
              setIsLoadProgress(false);
              Class_ETC_MsgSuccess(MsgDescription.CFM001 , null);
            // });
          });
        });

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      } 
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }
  }

  function onclick_box2_OpenClosePositionSetting(){
    
      let classshowstaff = "direct-chat direct-chat-primary";
      if (document.getElementById("div_box2_OpenClosePositionSetting").className === classshowstaff)
      {
        box2_OpenCloseStaffPosition("position");
      }
      else
      {
        box2_OpenCloseStaffPosition("staff");
      }
  }

  function box2_OpenCloseStaffPosition(act){
    let classshowstaff = "direct-chat direct-chat-primary";
    let classshowposition = "direct-chat direct-chat-primary direct-chat-contacts-open";
    if (act === "staff")
    {
      document.getElementById("div_box2_OpenClosePositionSetting").className = classshowstaff;
      document.getElementById('btn_Position_setting_OpenClose').className = "btn btn-primary btn-xs";
    }
    else 
    {
      BindProOrgPosition_Getlist("new" , function() {
        document.getElementById("div_box2_OpenClosePositionSetting").className = classshowposition;
        document.getElementById('btn_Position_setting_OpenClose').className = "btn btn-primary btn-xs";
      });
    }
  }

  function onclick_resetStaff(){
    setIscntreset((iscntreset) => iscntreset + 1)
    setDdl_AddStaff(null)
    document.getElementById("ddl_box2s_positionstaff").value = '-1'

  }

  //#endregion

  //#region __ ProjectOrgPosition __

  async function BindProOrgPosition_Getlist(actpage , _callback) {

    let pdid = document.getElementById("hd_box2_pro_dept_id").value.trim();

    try {
      setListpop_getlist([]);
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "pro_id": pgProid.toString(),
        "pro_dept_id": pdid
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgPosition_Getlist",
        requestOptions
      );
      const json = await response.json();

      if (json.status_ID === 1) {
        if (json.total_Data > 0) {

          if (actpage === "new") {
            setPagepop(0);
          } 
          else if (actpage === "check") {
            if (rowsPerPagepop * (pagepop + 1) > json.total_Data) {
              let pagenow = Math.ceil(json.total_Data / rowsPerPagepop);
              setPagepop(pagenow === 0 ? 0 : pagenow - 1);
            }
          }
          setListpop_getlist(json.data);
          if (_callback != null) {
              _callback();
          }
        } else {
          setPagepop(0);
          setListpop_getlist([]);
          if (_callback != null) {
              _callback();
          }
        }
      }
      else
      {
        setPagepop(0);
        setListpop_getlist([]);
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setPagepop(0);
      setListpop_getlist([]);
      if (_callback != null) {
          _callback();
      }
    }

  }
  
  async function onclick_POPSorting(pro_pos_id , act){
    
    try {


      setIsLoadProgress(true);
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw;
      raw = JSON.stringify({
        "pro_pos_id": pro_pos_id.toString(),
        "pro_id": pgProid,
        "pro_dept_id": document.getElementById("hd_box2_pro_dept_id").value,
        "act": act
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgPosition_Sorting",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        BindProOrg_Staff_Getlist("" , function() {
          BindProOrgPosition_Getlist("" , function () {
            setIsLoadProgress(false);
          });
        });
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }
  }

  function onclick_POPDel(pro_pos_id){
    document.getElementById("hd_POPdel").value = pro_pos_id.toString();
    Class_ETC_Warning(MsgDescription.CFM002, SavedPositionDel);
  }
  
  async function SavedPositionDel(){
    
    try {
      setIsLoadProgress(true);

      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
     
      var raw;
      let pdid = document.getElementById("hd_box2_pro_dept_id").value.trim();
      raw = JSON.stringify({
        "pro_pos_id": document.getElementById("hd_POPdel").value.trim(),
        "pro_id": pgProid ,
        "pro_dept_id": pdid
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgPosition_Del",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {

        BindDDLPositionDept(pdid , "0" , "" ,function() {
          BindProOrgPosition_Getlist("check" , function () {
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
          });
        });

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      } 
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR003, null);
    }

  }

  function onclick_POPEdit(pro_pos_id
                          ,position_name 
                          ,rate_normal_hours
                          ,rate_ot
                          ,authority_timesheet
                          ,authority_payment
                          ,authority_timeoff
                          ,pos_rate_exp_extra
                          ,pos_rate_exp_travel
                          )
    {
      
      document.getElementById("hd_model_position_pos_id").value = pro_pos_id
      document.getElementById("txt_model_position_pos_name").value = position_name
      setData_model_position_pos_rate_WT(rate_normal_hours);
      setData_model_position_pos_rate_OT(rate_ot);
      setData_model_position_TS(authority_timesheet)
      setData_model_position_TO(authority_timeoff)
      setData_model_position_PM(authority_payment)

      setData_model_position_pos_rate_exp_extra(pos_rate_exp_extra);
      setData_model_position_pos_rate_exp_travel(pos_rate_exp_travel);


  }

  const onValueChange_model_position_pos_rate = (newValue , act) => {
    if (newValue === undefined) {

      if (act === "ot")
      {
        setData_model_position_pos_rate_OT("0");
      }
      else if (act === "extra")
      {
        setData_model_position_pos_rate_exp_extra("0");
      }
      else if (act === "travel")
      {
        setData_model_position_pos_rate_exp_travel("0");
      }
      else
      {
        setData_model_position_pos_rate_WT("0");
      }
    } else {
      if (act === "ot")
      {
        setData_model_position_pos_rate_OT(newValue);
      }
      else if (act === "extra")
      {
        setData_model_position_pos_rate_exp_extra(newValue);
      }
      else if (act === "travel")
      {
        setData_model_position_pos_rate_exp_travel(newValue);
      }
      else
      {
        setData_model_position_pos_rate_WT(newValue);
      }
    }
  }

  const onChange_Radio = (e , act ) => {
    if (act === "TS")
    {
      setData_model_position_TS(e.target.value)
    }
    else if (act === "TO")
    {
      setData_model_position_TO(e.target.value)
    }
    else
    {
      setData_model_position_PM(e.target.value)
    }
  }

  function onclick_POPSaveEdit(){

    setIsLoadProgress(true);
    var txtError = "";
    var msgetc = "";

    var isckot = true;
    var isoterror = "";
    var isoterrormsg = "";
    if (isSVOT === true)
    {
      if (document.getElementById("txt_model_position_pos_rate_OT").value.trim() === "")
      {
        isoterror = "txt_model_position_pos_rate_OT";
        isckot = false;
      }
      else if  (data_model_position_pos_rate_OT < 0)
      {
        isoterror = "txt_model_position_pos_rate_OT";
        isoterrormsg = "ERR017";
        isckot = false;
      }
    }

    if (document.getElementById("txt_model_position_pos_name").value.trim() === "")
    {
      txtError = "txt_model_position_pos_name";
    }
    else if (document.getElementById("txt_model_position_pos_rate_WT").value.trim() === "")
    {
      txtError = "txt_model_position_pos_rate_WT";
    }
    else if  (data_model_position_pos_rate_WT < 0)
    {
      txtError = "txt_model_position_pos_rate_WT";
      msgetc = "ERR017";
    }
    else if (isckot === false)
    {
      txtError = isoterror;
      msgetc = isoterrormsg;
    }
    else if (document.getElementById("txt_model_position_pos_rate_exp_extra").value.trim() === "")
    {
      txtError = "txt_model_position_pos_rate_exp_extra";
    }
    else if  (data_model_position_pos_rate_exp_extra < 0)
    {
      txtError = "txt_model_position_pos_rate_exp_extra";
      msgetc = "ERR017";
    }
    else if (document.getElementById("txt_model_position_pos_rate_exp_travel").value.trim() === "")
    {
      txtError = "txt_model_position_pos_rate_exp_travel";
    }
    else if  (data_model_position_pos_rate_exp_travel < 0)
    {
      txtError = "txt_model_position_pos_rate_exp_travel";
      msgetc = "ERR017";
    }

   
    if (txtError !== "")
    {
      setIsLoadProgress(false);
      Class_ETC_MsgErrorfocusByID((msgetc === "ERR017" ? MsgDescription.ERR017 :  MsgDescription.ERR001), txtError);
    }
    else
    {

      if (data_model_position_TS !== "0" && 
          data_model_position_TS !== "1" && 
          data_model_position_TS !== "2" && 
          data_model_position_TS !== "3" 
          )
      {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR013 , null);
      }
      else if (data_model_position_TO !== "0" && 
               data_model_position_TO !== "1" && 
               data_model_position_TO !== "2" && 
               data_model_position_TO !== "3"
            )
      {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR014 , null);
      }
      else if (data_model_position_PM !== "0" && 
               data_model_position_PM !== "1"
            )
      {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR015 , null);
      }
      else
      {
        SavedPositionEdit();
      }
    }
  }

  async function SavedPositionEdit(){
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

     
      var raw;
      let dept_id = document.getElementById("hd_box2_pro_dept_id").value.trim();
      let pro_pos_id = document.getElementById("hd_model_position_pos_id").value.trim();
     
      raw = JSON.stringify({
        "pro_pos_id": pro_pos_id,
        "pro_id": pgProid,
        "pro_dept_id": dept_id,
        "pos_name": document.getElementById("txt_model_position_pos_name").value.trim(),
        "pos_rate_WT": data_model_position_pos_rate_WT.toString(),
        "pos_rate_OT": data_model_position_pos_rate_OT.toString(),
        "pos_auth_timesheet": data_model_position_TS.toString(),
        "pos_auth_timeoff": data_model_position_TO.toString(),
        "pos_auth_payment": data_model_position_PM.toString(),
        "pos_rate_exp_extra": data_model_position_pos_rate_exp_extra.toString(),
        "pos_rate_exp_travel": data_model_position_pos_rate_exp_travel.toString()
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ProjectOrgPosition_Edit",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        
        BindProOrg_Staff_Getlist("" , function() {
          BindProOrgPosition_Getlist("" , function () {
            document.getElementById("modalposition_Close").click();
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM001 , null);
          });
        });

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }
  }



  //#endregion


  //#region __ Copy ProjectOrg __

  //  // เมื่อกด ESC
  // const handleKeyDown = (event) => {
  //   if (event.key === 'Escape') {
  //     let hd_isModal =  document.getElementById("hd_isModal").value;
  //     if(hd_isModal === '1'){
  //       AfterPopClose();
  //     }   
  //   }
  // }

  // // เมื่อคลิกพื้นหลัก
  // const handleBackgroundClick  = (event) => {
  //   let hd_isModal =  document.getElementById("hd_isModal").value;
  //   if (modalRef.current && modalRef.current === event.target && hd_isModal === '1') {
  //     AfterPopClose();
  //   }
  // }

  // function AfterPopClose(){
  //   document.getElementById("hd_isModal").value = 0;
  //   document.getElementById("modalCopyProject_Close").click();
  //   SaveProAE();
  // }

  
  function onclick_CancelCopyProjectOrg(){
    document.getElementById("modalCopyProject_Close").click();
    SaveProAE();
  }

  function onclick_CopyProjectOrg()
  { 
    setIscntreset((iscntreset) => iscntreset + 1)
    document.getElementById("hd_isModal").value = 1;
    document.getElementById("btn_copy_project").click();
    document.getElementById("div_listpos").style.display = "none";
  }

  function OnChangevalueProjectOrg(e){
    setSearchProjectOrg(e)
    if(e === null){
      document.getElementById("div_listpos").style.display = "none";
    }else{
      if(e.value === -1 ){
        document.getElementById("div_listpos").style.display = "none";
      }else{
        document.getElementById("div_listpos").style.display = "";
        BindListPOS(e.value)
      }
    }
    
  }


  async function BindListPOS(pro_id,_callback) {
    try {
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        "pro_id": pro_id.toString(),
      });
      
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_GetListPOS",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
            setListcopypos(json.data);
          if (_callback != null) {
            _callback();
          }
        } else {
          setListcopypos([]);
          if (_callback != null) {
            _callback();
          }
        }
      }else{
        setListcopypos([]);
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      setListcopypos([]);
        if (_callback != null) {
            _callback();
        }
    }
  } 

  

async function onclick_SaveCopyProjectOrg()
  {
    setIsLoadProgress(true);
    var txtError = "";

    if (searchProjectOrg !== null)
    {
        if (searchProjectOrg.value === -1 || searchProjectOrg.value === '-1')
        {
          txtError = "searchProjectOrg";
        }
    }
    else if (searchProjectOrg === null)
    {
      txtError = "searchProjectOrg";
    }

    if (txtError !== "")
    {
      if (txtError === "searchProjectOrg")
      {

        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR001 , SelectFocas_ddlPorjectOrg);
      }
    }
    else
    {
      SaveCopyProjectOrg()
    }

  }

  function SelectFocas_ddlPorjectOrg(){
    selectRef_PorjectOrg.current?.focus()
  }

  async function SaveCopyProjectOrg()
  {
    setIsLoadProgress(true);
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      
      let SD = document.getElementById("txt_proAE_pro_start_date").value.trim()
      let ED = document.getElementById("txt_proAE_pro_end_date").value.trim()
      let pn = document.getElementById("txt_proAE_pro_name").value.trim();
      let cid = document.getElementById("ddl_proAE_cus_id").value.trim();
      let py = "";
      let pt = "";
      let pic = "0";
      let ps = (dataproae_pro_status === true ? "1" : "0");
      let pd = document.getElementById("txt_proAE_pro_desc").value.trim();
      let pro_id = searchProjectOrg.value.toString();
      var raw;
      
        raw = JSON.stringify({
          "pro_id": pro_id,
          "pro_name": pn,
          "cus_id": cid,
          "pro_year": py,
          "pro_type": pt,
          "pro_start_date": SD,
          "pro_end_date": ED,
          "pro_is_close": pic,
          "pro_status": ps,
          "pro_desc": pd
        });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_Copy",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        setIsLoadProgress(false);
        document.getElementById("hd_Proid_Edit").value = json.pro_id.toString();
        Class_ETC_MsgSuccess(MsgDescription.CFM001, GotoProject);

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR002, null);
    }

  }

  //#endregion

  //#endregion


  return (
    <>
      <Helmet>
        <title>Project</title>
      </Helmet>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <div className="content-wrapper">
        <div className="content-header">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="container-fluid">
                <h1 className="display-5 text-center">
                  {" "}
                  <i className="fa fa-building" /> Project{" "}
                  <span className="text-small">({pgAct}) </span> 
                </h1>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">


            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="card">
                  <div className="card-header d-none">
                    <h3 className="card-title">Information </h3>
                  </div>
                  <div className="card-body pb-0">
                    <div className="form-horizontal">
                      <div className="form-group row mb-2">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Project name<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-10">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Project name"
                            id="txt_proAE_pro_name"
                          />
                        </div>
                      </div>
                      <div className="form-group row mb-2">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Customer<span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-6">
                          {dataproae_cusid !== "" && (
                            <select
                              id="ddl_proAE_cus_id"
                              className="form-control form-control-sm"
                              style={{ width: "100%" }}
                              defaultValue={dataproae_cusid}
                            >
                              <option value="-1">
                                {ConfigETC.ddl_pleaseselect}
                              </option>
                              {listcus.length > 0 &&
                                listcus.map((en) => (
                                  <option key={en.value} value={en.value}>
                                    {en.label}
                                  </option>
                                ))}
                              {listcus_inactive.length > 0 &&
                                listcus_inactive.map((en) => (
                                  <option key={en.value} value={en.value}>
                                    {en.label}
                                  </option>
                                ))}
                            </select>
                          )}
                        </div>
                       
                      </div>

                    
                      <div className="form-group row mb-2">
                      <label className="text-sm col-sm-2 col-form-label text-right">
                          Start Date{" "} <i className="far fa-calendar-alt" />
                        </label>
                        <div className="col-sm-2">
                          <div
                            className="input-group"
                          >
                            <DatePickerComponent
                              id="txt_proAE_pro_start_date"
                              format="dd/MM/yyyy"
                              strictMode={true}
                            />
                          </div>
                        </div>
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          End Date{" "} <i className="far fa-calendar-alt" />
                        </label>
                        <div className="col-sm-2">
                          <div
                            className="input-group"
                          >     
                            <DatePickerComponent
                                id="txt_proAE_pro_end_date"
                                format="dd/MM/yyyy"
                                strictMode={true}
                            />

                          </div>
                        </div>
                        <label className="text-sm col-sm-2 col-form-label text-right">
                           Status{" "}
                        </label>
                        <div className="col-sm-2">
                          <BootstrapSwitchButton
                              onChange={(checked) => {
                                  setDataproae_pro_status(checked)
                                }}
                                checked={dataproae_pro_status}
                                width={ConfigETC.SwitchButton_in_active_width} 
                                onlabel={ConfigETC.SwitchButton_active_text}
                                onstyle={ConfigETC.SwitchButton_active_color}
                                offlabel={ConfigETC.SwitchButton_inactive_text}
                                offstyle={ConfigETC.SwitchButton_inactive_color}
                                size="xs"
                            /> {" "}
                           
                             <i className="fas fa-info-circle text-small text-muted tip"  title="IF it is Inactive affects recording of Time sheet" ></i>
                        </div>
                       
                        

                      </div>

                      <div className="form-group row mb-2">
                      <label className="text-sm col-sm-2 col-form-label text-right">
                          Description
                        </label>
                        <div className="col-sm-10">
                          <textarea name="Text1" cols="40" rows="2" 
                            className="form-control form-control-sm"
                            placeholder="Description"
                            id="txt_proAE_pro_desc" ></textarea>
                          <input type="hidden" id="hd_Proid_Edit" ></input>
                        </div>
                     
                       

                      </div>
                     
                      <div className="form-group row mb-1 d">
                     
                       </div>

                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer p-2">
                    
                    <button
                      type="button"
                      className="btn btn-default btn-sm"
                      onClick={onclick_Cancel}
                    >
                      <i className="fa  fa-times" /> Cancel
                    </button>

                    {(isPermissionAdd || isPermissionEdit) &&
                      <button
                        type="button"
                        className="btn btn-primary btn-sm float-right"
                        onClick={onclickSaveProAE}
                      >
                        <i className="fas  fa-save" /> Save
                      </button>
                    }
                    
                  </div>
                </div>
              </div>
            </div>

            
            {pgAct === "Edit" &&
            <>
            {/* ########################### Project Organization ########################### */}
            <div className="row pt-4 pb-2">
              <div className="col-md-12">
                <div className="container-fluid">
                  <h3 className="text-center">
                    <i className="fas fa-sitemap" /> Project Organization
                  </h3>
                </div>
              </div>
            </div>


            <div className="row">
            <div className="col-md-3">
               
              <div className="card ">
                <div className="card-header">
                  <h3 className="card-title">Department</h3>
                  <div className="card-tools">
                  
                    {(isPermissionEdit && isService_department) &&
                      <button
                          className="btn btn-primary btn-xs"
                          title="Add Department"
                          onClick={onclick_PODAdd}
                          data-target="#modal-department"
                          data-toggle="modal"
                        >
                          <i className="fas fa-plus" />
                        </button>
                    }
                    <button
                      id="btn_Dept_setting_OpenClose"
                      className="btn btn-primary btn-xs"
                      title="Department Management"
                      data-target="#modal-dept-setting"
                      data-toggle="modal"
                      onClick={onclick_pod_cl_right_dept}
                    >
                      <i className="fas fa-cog" />
                    </button>
                   
                  </div>
                </div>
                <div className="card-body p-0">
                        
                      <ul className="nav flex-column nav-tabs "
                          id="vert-tabs-tab"
                          role="tablist"
                          aria-orientation="vertical"
                        >
                          {(listpod_getcount.length > 0 &&
                            listpod_getcount.map((en) => (
                              <li className="text-sm nav-item" key={en.rowindex}>
                              <a
                                className={
                                    (( (isSorting === true) && (en.pro_dept_id.toString() === a_box2left_dept_sorting.toString()) ) ? "nav-link active" 
                                    : 
                                    ((isClick === true) && (en.pro_dept_id.toString() === a_box2left_dept.toString()) ? "nav-link active" 
                                    : 
                                    "nav-link")
                                    )
                                  }
                                id={"a_box2left_dept_"  + en.rowindex.toString()}
                                onClick={() => onclick_pod_cl_right_staff(en.rowindex , en.pro_dept_id , en.dept_name)}
                                href="#!"
                                data-toggle="pill"
                              >
                                {(en.rowindex === 1 &&
                                  <i className="fas fa-thumbtack  align-middle" style={{ fontSize: "0.8rem" }}/>        
                                  ) 
                                ||
                                (
                                  <i className="far fa-circle fa-xs  align-middle" style={{ fontSize: "0.4rem" }}/> 
                                )
                                }
                                {" "}{en.dept_name}
                                <span id={en.rowindex} className="float-right">
                                  <span className="badge bg-light">
                                    <i className="fas fa-user" /> {en.count_staff}
                                  </span>
                                </span>
                              </a>
                              </li>
                            )))}
                            
                        
                        </ul>
                  
                  
                </div>
               
                {/* /.card-body */}
              </div>

             

                    {/* <a 
                            id="a_box2left_deptsetting"
                            role="button"
                            href="#!"
                            data-toggle="pill"
                            onClick={onclick_pod_cl_right_dept}
                            className="btn btn-default btn-block mb-3 text-muted btn-xs"
                          >
                              <i className="fas fa-cog " /> Department setting
                            
                          </a> */}
            </div>
            {/* /.col */}
            <div className="col-md-9">
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title text-bold">
                  {a_box2left_dept_name}
                  </h3>
                 
                  {/* /.card-tools 
                  <div className="card-tools ">
                    <small>Position setting{" "}</small>
                   
                  </div>*/}
                </div>
                {/* /.card-header */}
                <div className="card-body p-0">


                  <div className="table-responsive mailbox-messages">
                  <div className="tab-content" >
                  <input type="hidden" id="hd_PODdel" ></input>          

            {/* ########################### Project Organization Staff Position list ########################### */}

                          <div
                            className={cn_divbox2_right_staff}
                            id="div_box2_right_staff"
                          >
                            <input type="hidden" id="hd_box2_pro_dept_id" ></input>
                            <input type="hidden" id="hd_box2_pro_dept_name" ></input>
                            <input type="hidden" id="hd_POSdel" ></input>
                            
                            <div id="div_box2_OpenClosePositionSetting" className=" direct-chat direct-chat-primary">
                              {/*<div className="card-header">
                                <h3 className="card-title">
                                  {" "}
                                  Staff {" "}
                                </h3>
                                
                            </div>*/}
                              <div className="card-body p-0">

            {/* ########################### Project Staff ########################### */}

                                <div
                                  className="direct-chat-messages p-0"
                                 style={{ height: "auto" , minHeight : "300px" }}
                                  //style={{ height: "auto"}}
                                >
                                  <div className="p-0">
                                    <div className="">
                                      
                                      <TableContainer>
                                        <Table 
                                        stickyHeader
                                        aria-label="sticky table"
                                        className="table table-head-fixed table-hover">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell style={{ width: "5%" , fontWeight : "bold"}}>#</TableCell>
                                              <TableCell style={{ width: "40%" , fontWeight : "bold" }}>
                                                Staff {" "}
                                                <button
                                                  id="btn_add"
                                                  className="btn btn-primary btn-xs"
                                                  title="Add Staff and Position"
                                                  data-target="#modal-staff-add"
                                                  data-toggle="modal"
                                                  onClick={onclick_resetStaff}
                                                >
                                                  <i className="fas fa-plus" /> 
                                                </button>
                                              </TableCell>
                                              <TableCell style={{ width: "25%" , fontWeight : "bold" }}>
                                                Position{" "}
                                                <button
                                                  id="btn_Position_setting_OpenClose"
                                                  className="btn btn-primary btn-xs"
                                                  title="Position Management"
                                                  onClick={onclick_box2_OpenClosePositionSetting}
                                                >
                                                  <i className="fas fa-cog" />
                                                </button>

                                              </TableCell>
                                              
                                              <TableCell
                                                style={{ width: "15%" , fontWeight : "bold" }}
                                                className="text-left"
                                              >
                                                Staff Status{" "}
                                              </TableCell>
                                              <TableCell
                                                style={{ width: "15%" , fontWeight : "bold" }}
                                                className="text-center"
                                              >
                                                {" "}
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>

                                            {(listpos_getlist.length === 0 && (
                                                <TableRow key={1}>
                                                  <TableCell colSpan={5} align="center">
                                                    {ConfigETC.NoData}
                                                  </TableCell>
                                                </TableRow>
                                              )) ||
                                              listpos_getlist
                                                .slice(
                                                  pagepos * rowsPerPagepos,
                                                  pagepos * rowsPerPagepos + rowsPerPagepos
                                                )
                                                .map((row) => (

                                                  <TableRow key={row.rowindex} >
                                                    <TableCell>{row.rowindex}</TableCell>
                                                    <TableCell>
                                                      <div>{row.staff_fullname}</div>
                                                    </TableCell>
                                                    <TableCell>
                                                      <div className="">
                                                        {row.position_name_show}
                                                      </div>
                                                    </TableCell>
                                                   
                                                    <TableCell className="text-left  align-top">
                                                      
                                                      {(isPermissionEdit &&
                                                        <div className="custom-checkbox check-to-button">
                                                          <label>
                                                              <input type="checkbox" id={"chk_list_POS_status" + row.rowindex.toString()}
                                                              defaultChecked={row.staff_status === 1 ? true : false} 
                                                              onClick={event  => onclick_POSEdit(event , row.staff_code)}
                                                              />
                                                            <span>{row.staff_status_str}</span>
                                                          </label>
                                                        </div>
                                                      ) ||
                                                      (
                                                        <>
                                                          <div className="custom-checkbox check-to-button">
                                                            <label>
                                                                <input type="checkbox" id={"chk_list_POS_status" + row.rowindex.toString()}
                                                                defaultChecked={row.staff_status === 1 ? true : false} disabled 
                                                                />
                                                              <span>{row.staff_status_str}</span>
                                                            </label>
                                                          </div>
                                                        </>
                                                      )
                                                      }

                                                    </TableCell>
                                                    <TableCell className="text-right  align-top">
                                                      <span className="btn-group btn-group-sm">
                                                        {(isPermissionEdit) &&
                                                          <a
                                                            href="#!"
                                                            className="btn btn-primary"
                                                            title="Change position or department"
                                                            data-target="#modal-move-staff"
                                                            data-toggle="modal"
                                                            onClick={() => onclick_POS_Move(row.position_name , row.staff_code , row.staff_fullname)}
                                                          >
                                                            <i className="fas fa-exchange-alt" />
                                                          </a>
                                                        }

                                                        {(isPermissionDel) &&
                                                          <a
                                                            href="#!"
                                                            data-toggle="pill"
                                                            className="btn btn-default"
                                                            title="delete from project"
                                                            onClick={() => onclick_POS_SaveDel(row.staff_code)}
                                                          >
                                                            <i className="fas fa-trash-alt" />
                                                          </a>
                                                        }
                                                        </span>
                                                    </TableCell>
                                                  </TableRow>

                                            ))} 
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                      {listpos_getlist.length > 0 && (
                                        <TablePagination
                                          rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                                          component="div"
                                          count={listpos_getlist.length}
                                          rowsPerPage={rowsPerPagepos}
                                          page={pagepos}
                                          onPageChange={handleChangePagepos}
                                          onRowsPerPageChange={handleChangeRowsPerPagepos}
                                          ActionsComponent={PaginationActions}
                                        />
                                      )}

                                    </div>
                                  </div>

                                

                                </div>
                              
            {/* ########################### Project  Staff ########################### */}
                              

                              
            {/* ########################### Project  Position ########################### */}

                                <div
                                  className="direct-chat-contacts"
                                  style={{ height: "auto" }}
                                >
                                  <input type="hidden" id="hd_POPdel" ></input>
                                
                                  <div className="card m-2 shadow" >
                                      <div className="card-header">
                                          <h4 className="card-title text-bold">
                                              Position Setting
                                          </h4>
                                        <div className="card-tools ">
                                          <small>{" "}</small>
                                          <button
                                                      id="btn_Position_setting_OpenClose2"
                                                      className="btn btn-default btn-xs"
                                                      title="Close Position Management"
                                                      onClick={onclick_box2_OpenClosePositionSetting}
                                                    >
                                                      Close <i className="fas fa-times fa-lg" />
                                                    </button>
                                        </div>
                                      </div>
                                   <div className="card-body">
                                  <TableContainer>
                                    <Table 
                                      stickyHeader
                                      aria-label="sticky table"
                                      className="table table-head-fixed table-hover"
                                      border={0}>
                                      <TableHead>
                                        <TableRow className="pt-4">
                                          <TableCell
                                            style={{
                                              width: "5%",
                                              backgroundColor: "#f9f9f9",
                                            }}
                                            rowSpan={2}
                                            className="align-middle"
                                          >
                                            #
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              width: "20%",
                                              backgroundColor: "#f9f9f9",
                                              fontWeight: "bold"
                                            }}
                                            rowSpan={2}
                                            className="align-middle"
                                          >
                                            Position{" "}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              width: "8%",
                                              backgroundColor: "#f9f9f9",
                                              fontWeight: "bold"
                                            }}
                                            rowSpan={2}
                                            className="align-middle"
                                          >
                                            Staff{" "}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              width: "7%",
                                              backgroundColor: "#f9f9f9",
                                              fontWeight: "bold"
                                            }}
                                            colSpan={4}
                                            className="text-center align-top border-right"
                                          >
                                            Rate 
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              width: "20%",
                                              backgroundColor: "#f9f9f9",
                                              fontWeight: "bold"
                                            }}
                                            colSpan={2}
                                            className="text-center align-top"
                                          >
                                            Authority
                                          </TableCell>

                                          

                                          {(isPermissionEdit || isPermissionDel) && 
                                            <>
                                              <TableCell
                                                style={{
                                                  width: "10%",
                                                  backgroundColor: "#f9f9f9",
                                                  fontWeight: "bold"
                                                }}
                                                rowSpan={2}
                                                className="text-center align-middle"
                                              >
                                                {(isPermissionEdit) &&
                                                  <>
                                                    Priority{" "}
                                                  </>
                                                }
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  width: "10%",
                                                  backgroundColor: "#f9f9f9",
                                                }}
                                                rowSpan={2}
                                                className="text-center align-top"
                                              >
                                                {" "}
                                               
                                              </TableCell>
                                            </>
                                          } 



                                        </TableRow>
                                        <TableRow
                                          className="pt-4"
                                          style={{ backgroundColor: "#f9f9f9" }}
                                        >
                                          <TableCell
                                            colSpan={(isSVOT === true ? 1 : 2)}
                                            style={{
                                              width: "5%",
                                              backgroundColor: "#f9f9f9",
                                              fontWeight: "bold"
                                            }}
                                            className="text-center text-sm align-top"
                                          >
                                            WT<br/><small>(Baht/hr.)</small>
                                          </TableCell>

                                          {isSVOT === true && 
                                            <TableCell
                                              style={{
                                                width: "5%",
                                                backgroundColor: "#f9f9f9",
                                                fontWeight: "bold"
                                              }}
                                              className="text-center text-sm align-top"
                                            >
                                              OT<br/><small>(Baht/hr.)</small>
                                            </TableCell>
                                          }
                                          <TableCell
                                            style={{
                                              width: "10%",
                                              backgroundColor: "#f9f9f9",
                                              fontWeight: "bold"
                                            }}
                                            rowSpan={2}
                                            className="text-center align-top"
                                          >
                                            Per diem allowance<br/><small>(Baht/day)</small>
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              width: "10%",
                                              backgroundColor: "#f9f9f9",
                                              fontWeight: "bold"
                                            }}
                                            rowSpan={2}
                                            className="text-center align-top border-right"
                                          >
                                           Travel<br/><small>(Baht/km.)</small>
                                          </TableCell>

                                          <TableCell
                                            style={{
                                              width: "10%",
                                              backgroundColor: "#f9f9f9",
                                              fontWeight: "bold"
                                            }}
                                            className="text-center text-sm align-top"
                                          >
                                            Timesheet
                                          </TableCell>
                                          {/* <TableCell
                                            style={{
                                              width: "10%",
                                              backgroundColor: "#f9f9f9",
                                              fontWeight: "bold"
                                            }}
                                            className="text-center text-sm align-top"
                                          >
                                            Payment
                                          </TableCell> */}
                                          <TableCell
                                            style={{
                                              width: "10%",
                                              backgroundColor: "#f9f9f9",
                                              fontWeight: "bold"
                                            }}
                                            className="text-center text-sm align-top"
                                          >
                                            Timeoff
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                      {(listpop_getlist.length === 0 && (
                                          <TableRow key={99}>
                                            <TableCell colSpan={(isPermissionEdit || isPermissionDel ? 9 : 7)} align="center">
                                              {ConfigETC.NoData}
                                            </TableCell>
                                          </TableRow>
                                        )) ||
                                        listpop_getlist
                                            .slice(
                                              pagepop * rowsPerPagepop,
                                              pagepop * rowsPerPagepop + rowsPerPagepop
                                            )
                                            .map((row) => (

                                            <TableRow key={row.rowindex}>
                                              <TableCell>{row.rowindex}</TableCell>
                                              <TableCell>
                                                <div className="text-bold">
                                                  {row.position_name}
                                                </div>
                                              </TableCell>
                                              <TableCell>
                                                <span className="badge bg-light">
                                                  <i className="fas fa-user" /> {row.count_staff}
                                                </span>
                                              </TableCell>
                                              <TableCell colSpan={(isSVOT === true ? 1 : 2)} >
                                                <div>{row.rate_normal_hours_str}</div>
                                              </TableCell>
                                              {isSVOT === true &&
                                                <TableCell>
                                                  <div>{row.rate_ot_str}</div>
                                                </TableCell>
                                              }
                                              <TableCell>
                                                <div>{row.pos_rate_exp_extra_str}</div>
                                              </TableCell>
                                              <TableCell className="border-right">
                                                <div>{row.pos_rate_exp_travel_str}</div>
                                              </TableCell>
                                              <TableCell className="text-center">
                                                <span className={(row.authority_timesheet === 0 ? ConfigETC.Timesheet_None :
                                                                 (row.authority_timesheet === 1 ? ConfigETC.Timesheet_Reviewer : 
                                                                 (row.authority_timesheet === 2 ? ConfigETC.Timesheet_Approver : 
                                                                  ConfigETC.Timesheet_SelfApprove )))}>
                                                  {row.authority_timesheet_str}
                                                </span>
                                              </TableCell>
                                              <TableCell className="text-center">
                                                <span className={(row.authority_timeoff === 0 ? ConfigETC.Timeoff_None :
                                                                 (row.authority_timeoff === 1 ? ConfigETC.Timeoff_Reviewer : 
                                                                 (row.authority_timeoff === 2 ? ConfigETC.Timeoff_Approver : 
                                                                  ConfigETC.Timeoff_SelfApprove )))}>
                                                  {row.authority_timeoff_str}
                                                </span>
                                              </TableCell>
                                              
                                             

                                              {(isPermissionEdit || isPermissionDel) &&
                                                <>
                                                  <TableCell className="text-center  align-top">
                                                    <div className="btn-group btn-group-sm">
                                                      {row.rowindex !== 1 && isPermissionEdit &&
                                                        <a href="#!" title="up" 
                                                        data-toggle="pill"
                                                        onClick={() => onclick_POPSorting(row.pro_pos_id , "up")}  >
                                                          <i className="fas fa-arrow-alt-circle-up fa-lg" />
                                                        </a>
                                                      }
                                                      {row.rowindex !== listpop_getlist.length && isPermissionEdit &&
                                                        <a href="#!" title="down"
                                                        data-toggle="pill"
                                                        onClick={() => onclick_POPSorting(row.pro_pos_id , "down")}   >
                                                          <i className="fas fa-arrow-alt-circle-down fa-lg" />
                                                        </a>
                                                      }
                                                    </div>
                                                  </TableCell>
                                                  <TableCell className="text-right  align-top">
                                                    <span className="btn-group btn-group-sm">
                                                      {(isPermissionEdit) &&
                                                        <a
                                                          href="#!"
                                                          className="btn btn-primary"
                                                          title="แก้ไข"
                                                          data-target="#modal-position"
                                                          data-toggle="modal"
                                                          onClick={() => onclick_POPEdit(row.pro_pos_id
                                                                                        ,row.position_name 
                                                                                        ,row.rate_normal_hours
                                                                                        ,row.rate_ot
                                                                                        ,row.authority_timesheet.toString()
                                                                                        ,row.authority_payment.toString()
                                                                                        ,row.authority_timeoff.toString()
                                                                                        ,row.pos_rate_exp_extra
                                                                                        ,row.pos_rate_exp_travel
                                                                                        )} 
                                                        >
                                                          <i className="fas fa-pencil-alt" />
                                                        </a>
                                                      }
                                                      
                                                      {(isPermissionDel) &&
                                                        <a
                                                          href="#!"
                                                          data-toggle="pill"
                                                          className="btn btn-default"
                                                          title="ลบ"
                                                          onClick={() => onclick_POPDel(row.pro_pos_id)}
                                                        >
                                                          <i className="fas fa-trash" />
                                                        </a>
                                                      }
                                                      </span>
                                                  </TableCell>
                                                </>
                                              }

                                            </TableRow>



                                        ))}

                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                  {listpop_getlist.length > 0 && (
                                    <TablePagination
                                      rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                                      component="div"
                                      count={listpop_getlist.length}
                                      rowsPerPage={rowsPerPagepop}
                                      page={pagepop}
                                      onPageChange={handleChangePagepop}
                                      onRowsPerPageChange={handleChangeRowsPerPagepop}
                                      ActionsComponent={PaginationActions}
                                    />
                                  )}
                                  </div>
                                </div>


                                </div>
                            
            {/* ########################### Project Position ########################### */}
                            
                                {/* /.direct-chat-pane */}
                              </div>
                              {/* /.card-body */}
                              {/* /.card-footer*/}
                            </div>
                          </div>
            {/* ########################### Project Organization Staff Position list ########################### */}


                        
                  </div>



                    {/* /.table */}
                  </div>
                  {/* /.mail-box-messages */}
                </div>
                {/* /.card-body */}
              
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>



            
            {/* ########################### Project Organization ########################### */}
            </>
          }








            {/* /.container-fluid */}
          </div>
        </section>
        {/* /.content */}
      </div>
      {/* ########################### Project Organization ########################### */}



      {/* ########################### Pop up Pro Organization dept  ########################### */}
      <div className="modal fade" id="modal-department">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <i className="fas fa-cubes" /> Department{" "}
                <span className="text-sm text-muted">({pod_actAE} from setting)  </span>
              </h4>
              <button
                id="modaldept_Close"
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-horizontal">
                <div className="form-group row">
                  <label className="text-sm col-sm-3 col-form-label">
                    Department <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-9">

                    <select
                      id="ddl_deptAdd_pro_dept_id"
                      className="form-control form-control-sm"
                      style={{ width: "100%" }}
                    >
                      <option value="-1">{ConfigETC.ddl_pleaseselect}</option>
                      {listddldept.length > 0 &&
                        listddldept.map((en) => (
                          <option key={en.dept_id} value={en.dept_id}>
                            {en.dept_name}
                          </option>
                        ))}
                    </select>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Department Name"
                      id="txt_deptEdit_dept_name"
                    />  

                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
              {(isPermissionEdit) &&
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={OnclickSave_ModeldepartmentAE}
                >
                  <i className="fa  fa-save" /> Save
                </button>
              }
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>

      {/* ########################### Pop up Pro Organization dept  ########################### */}


      {/* ########################### Pop up Pro Organization Move Staff ########################### */}
      <div className="modal fade" id="modal-move-staff">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <i className="fas fa-exchange-alt" /> Move Staff{" "}
                <span className="text-sm text-muted">(edit)</span>
              </h4>
              <button
                type="button"
                id="modalmovestaff_Close"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-horizontal">
                <div>
                  <span className="text-bold">
                    <input type="hidden" id="hd_model_move_staff_staffcode" ></input>
                    <i className="fa fa-user" /> <span id="lbl_model_move_staff_FullName"></span>
                  </span>
                </div>
                <br />
                <div>From</div>
                <div className="form-group row">
                  <label className="text-sm col-sm-3 col-form-label">
                    Department
                  </label>
                  <div className="col-sm-9">
                    <span id="lbl_model_move_staff_DeptName"></span>
                  </div>
                  <label className="text-sm col-sm-3 col-form-label">
                    Position
                  </label>
                  <div className="col-sm-9">
                    <span id="lbl_model_move_staff_Position_Name" ></span>
                  </div>
                </div>
                <div>To</div>
                <div className="form-group row">
                  <label className="text-sm col-sm-3 col-form-label">
                    Department <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-9">
                    <select
                      id="ddl_model_move_staff_dept"
                      className="form-control form-control-sm"
                      style={{ width: "100%" }}
                      onChange={onchange_ddl_model_move_staff_dept} 
                    >
                      <option value="-1" >{ConfigETC.ddl_pleaseselect}</option>
                      {listpod_getcount.length > 0 &&
                        listpod_getcount.map((en) => 
                        <option key={en.pro_dept_id} value={en.pro_dept_id} >
                          {en.dept_name}
                        </option>
                        )
                      }
                    </select>
                  </div>
                  <label className="text-sm col-sm-3 col-form-label">
                    Position <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-9">
                    <select
                      id="ddl_model_move_staff_position"
                      className="form-control form-control-sm"
                      style={{ width: "100%" }}
                      onChange={onchange_ddl_model_move_staff_position} 
                    >
                      <option value="-1" >{ConfigETC.ddl_pleaseselect}</option>
                      {listddl_positiondeptMove.length > 0 &&
                        listddl_positiondeptMove.map((en , index) => 
                        <option key={index} value={en.pro_pos_id + "|" + en.type} >
                          {en.position_name}
                        </option>
                        )
                      }
                      {ismorepositionshowMove === true &&
                        <option value="-99" >{ConfigETC.ddl_moreposition}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>

              {(isPermissionEdit) &&
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onclick_POS_MoveSave}
                >
                  <i className="fa  fa-save" /> Save
                </button>
              } 

            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      {/* ########################### Pop up Pro Organization Move Staff ########################### */}


      {/* ########################### Pop up Pro Organization Edit Position ########################### */}
      <div className="modal fade" id="modal-position">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <i className="fas fa-graduation-cap" /> Position{" "}
                <span className="text-sm text-muted">(edit)</span>
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="modalposition_Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">

              <div className="form-horizontal">
                
                <div className="form-group row m-1">
                  <label className="text-small col-sm-2 col-form-label">Position name <span className="text-danger">*</span> </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="txt_model_position_pos_name"
                    />
                    <input
                      type="hidden"
                      className="form-control form-control-sm"
                      id="hd_model_position_pos_id"
                    />
                  </div>
                </div>

                <div className="form-group row m-1">
                  <label className="text-sm col-sm-2 col-form-label text-small">Rate </label>
                  
                  <div className="col-sm-10">
                    <div className="row mt-2">
                      <div className="text-sm col-sm-2 col-form-label text-small text-right">Work time <span className="text-danger">*</span> </div>
                      <div className="col-sm-4">
                      <div className="input-group">
                      <CurrencyInput
                        id="txt_model_position_pos_rate_WT"
                        name="input-name"
                        className="form-control form-control-sm"
                        decimalsLimit={2}
                        decimalScale={2}
                        value={data_model_position_pos_rate_WT}
                        onValueChange={(value) => onValueChange_model_position_pos_rate(value , "wt")}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text text-smaller">baht/hr. </span>
                      </div>
                      </div>
                      </div>

                       {isSVOT === true &&
                       <>
                          <div className="text-sm col-sm-2 col-form-label text-small text-right">Over time <span className="text-danger">*</span> </div>
                          <div className="col-sm-4">
                            <div className="input-group">
                              <CurrencyInput
                                id="txt_model_position_pos_rate_OT"
                                name="input-name"
                                className="form-control form-control-sm"
                                decimalsLimit={2}
                                decimalScale={2}
                                value={data_model_position_pos_rate_OT}
                                onValueChange={(value) => onValueChange_model_position_pos_rate(value , "ot")}
                              />
                              <div className="input-group-append">
                                <span className="input-group-text text-smaller">baht/hr. </span>
                              </div>
                            </div>
                          </div>
                        </>
                       }
                    </div>
                    <div className="row mt-2">
                        <div className="text-sm col-sm-2 col-form-label text-small text-right">Per diem allowance <span className="text-danger">*</span> </div>
                        <div className="col-sm-4">
                          <div className="input-group">
                            <CurrencyInput
                              id="txt_model_position_pos_rate_exp_extra"
                              name="input-name"
                              className="form-control form-control-sm"
                              decimalsLimit={2}
                              decimalScale={2}
                              value={data_model_position_pos_rate_exp_extra}
                              onValueChange={(value) => onValueChange_model_position_pos_rate(value , "extra")}
                            />
                            <div className="input-group-append">
                              <span className="input-group-text text-smaller">baht/day </span>
                            </div>
                          </div>
                        </div>

                        <div className="text-sm col-sm-2 col-form-label text-small text-right">Travel <span className="text-danger">*</span> </div>
                        <div className="col-sm-4">
                          <div className="input-group">
                            <CurrencyInput
                              id="txt_model_position_pos_rate_exp_travel"
                              name="input-name"
                              className="form-control form-control-sm"
                              decimalsLimit={2}
                              decimalScale={2}
                              value={data_model_position_pos_rate_exp_travel}
                              onValueChange={(value) => onValueChange_model_position_pos_rate(value , "travel")}
                            />
                            <div className="input-group-append">
                              <span className="input-group-text text-smaller">baht/km. </span>
                            </div>
                          </div>
                  </div>

                    </div>
                  </div>
                </div>

               
                <div className="form-group row m-1">

                  <label className="text-sm col-sm-2 col-form-label align-top">Authority
                  <br/>
                          <HtmlTooltip
                            title={
                              <React.Fragment>
                                <div className="text-left">
                                  <p> <span className={ConfigETC.Timesheet_SelfApprove}>Self-Approve</span> <br/> Can approve yourself.</p>
                                  <p><span className={ConfigETC.Timesheet_Approver}>Approver</span><br/> Approve lower positions.</p>
                                  <p><span className={ConfigETC.Timesheet_Reviewer}>Reviewer</span><br/> Review lower positions.</p>
                                  
                              </div> 
                              </React.Fragment>
                            }
                          >
                            <i className="fas fa-info-circle "  ></i>
                          </HtmlTooltip>
                  </label>
                  
                  <div className="col-sm-10">
                    <div className="row mt-2">
                      <div className="col-sm-2 text-right align-top text-small">Timesheet</div>
                      

                      <div className="col-sm-4">
                        <div className="form-group clearfix m-0">
                          
                          <div className="icheck-primary d-inline">
                            <input
                              type="radio" id="rdo_model_position_TS3" name="pos_auth_timesheet"
                              checked={data_model_position_TS === "3"} value="3"
                              onChange={(e) => onChange_Radio(e , "TS")}  
                            />
                            <label htmlFor="rdo_model_position_TS3">
                              <span className={ConfigETC.Timesheet_SelfApprove  + " ext-smaller"}>
                                Self-Approve
                              </span>
                            </label>
                          </div>
                          </div>
                          <div className="form-group clearfix m-0">
                          <div className="icheck-primary d-inline">
                            {" "}
                            <input type="radio" id="rdo_model_position_TS2" name="pos_auth_timesheet"
                            checked={data_model_position_TS === "2"} value="2"
                            onChange={(e) => onChange_Radio(e , "TS")} />
                            <label htmlFor="rdo_model_position_TS2">
                              <span className={ConfigETC.Timesheet_Approver + " text-smaller"}>
                                Approver
                              </span>
                            </label>
                          </div>
                          </div>
                          <div className="form-group clearfix m-0">
                          <div className="icheck-primary d-inline">
                            {" "}
                            <input type="radio" id="rdo_model_position_TS1" name="pos_auth_timesheet"
                            checked={data_model_position_TS === "1"} value="1"
                            onChange={(e) => onChange_Radio(e , "TS")}    />
                            <label htmlFor="rdo_model_position_TS1">
                              <span className={ConfigETC.Timesheet_Reviewer + " text-smaller"}>
                                Reviewer
                              </span>
                            </label>
                          </div>
                          </div>
                          <div className="form-group clearfix m-0">
                          <div className="icheck-primary d-inline">
                            <input type="radio" id="rdo_model_position_TS0" name="pos_auth_timesheet" 
                            checked={data_model_position_TS === "0"} value="0"
                            onChange={(e) => onChange_Radio(e , "TS")}  />
                            <label htmlFor="rdo_model_position_TS0">
                              <span className={ConfigETC.Timesheet_None + " text-smaller"}>
                                None
                              </span>
                            </label>
                          </div>

                         
                        </div>
                      </div>

                      <div className="col-sm-2 text-right align-top text-small">Timeoff</div>
                      <div className="col-sm-4">
                        <div className="form-group clearfix m-0">
                          <div className="icheck-primary d-inline">
                            {" "}
                            <input type="radio" id="rdo_model_position_TO3" name="pos_auth_timeoff" 
                              checked={data_model_position_TO === "3"} value="3"
                              onChange={(e) => onChange_Radio(e , "TO")}  />
                            <label htmlFor="rdo_model_position_TO3">
                              <span className={ConfigETC.Timeoff_SelfApprove  + " ext-smaller"}>Self-Approve</span>
                            </label>
                          </div>
                        </div>
                        <div className="form-group clearfix m-0">
                          <div className="icheck-primary d-inline">
                            {" "}
                            <input type="radio" id="rdo_model_position_TO2" name="pos_auth_timeoff" 
                              checked={data_model_position_TO === "2"} value="2"
                              onChange={(e) => onChange_Radio(e , "TO")}  />
                            <label htmlFor="rdo_model_position_TO2">
                              <span className={ConfigETC.Timeoff_Approver  + " ext-smaller"}>Approver</span>
                            </label>
                          </div>
                        </div>
                        <div className="form-group clearfix m-0">
                          <div className="icheck-primary d-inline">
                            {" "}
                            <input type="radio" id="rdo_model_position_TO1" name="pos_auth_timeoff" 
                              checked={data_model_position_TO === "1"} value="1"
                              onChange={(e) => onChange_Radio(e , "TO")}  />
                            <label htmlFor="rdo_model_position_TO1">
                              <span className={ConfigETC.Timeoff_Reviewer  + " ext-smaller"}>Reviewer</span>
                            </label>
                          </div>
                        </div>
                        <div className="form-group clearfix m-0">
                          <div className="icheck-primary d-inline">
                            <input
                              type="radio"
                              id="rdo_model_position_TO0"
                              name="pos_auth_timeoff"
                              checked={data_model_position_TO === "0"} value="0"
                              onChange={(e) => onChange_Radio(e , "TO")}  
                            />
                            <label htmlFor="rdo_model_position_TO0">
                              <span className={ConfigETC.Timeoff_None  + " ext-smaller"}>None</span>
                            </label>
                          </div>

                        </div>
                      </div>


                    </div>
                  </div>

                  <div style={{display:"none"}} > 

                    <label className="text-sm col-sm-3 col-form-label">
                      Payment
                    </label>
                    <div className="col-sm-9">
                      <div className="form-group clearfix p-0">
                        <div className="icheck-primary d-inline">
                          <input
                            type="radio"
                            id="rdo_model_position_PM0"
                            name="pos_auth_payment"
                            checked={data_model_position_PM === "0"} value="0"
                            onChange={(e) => onChange_Radio(e , "PM")}  
                          />
                          <label htmlFor="rdo_model_position_PM0">
                            <span className="badge bg-gray">no</span>
                          </label>
                        </div>
                        <div className="icheck-primary d-inline">
                          {" "}
                          <input type="radio" id="rdo_model_position_PM1" name="pos_auth_payment"
                            checked={data_model_position_PM === "1"} value="1"
                            onChange={(e) => onChange_Radio(e , "PM")}   />
                          <label htmlFor="rdo_model_position_PM1">
                            <span className="badge bg-success">yes</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    
                  </div>

                </div>

                
                

                
              </div>

            </div>
            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
              {(isPermissionEdit) &&
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onclick_POPSaveEdit}
                >
                  <i className="fa fa-save" /> Save
                </button>
              }
              </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      {/* ########################### Pop up Pro Organization Edit Position ########################### */}

      {/* ########################### Pop up Pro Department Setting ########################### */}
      <div className="modal fade" id="modal-dept-setting">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
              <i className="fas fa-cog"></i>   Department Setting
              </h4>
              <button
                type="button"
                id="modalDeptSetting_Close"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-horizontal">
                  {/* ########################### Project Organization Department Get list ########################### */}
                  <div
                            id="div_box2_right_dept"
                          >
                            <TableContainer>
                              <Table 
                              stickyHeader
                              aria-label="sticky table"
                              className="table table-head-fixed text-nowrap table-hover">
                                <TableHead>
                                  <TableRow>
                                      <TableCell
                                        style={{ width: "3%" , fontWeight : "bold" }}
                                        className="align-top"
                                      >
                                        #
                                      </TableCell>
                                      <TableCell
                                        style={{ width: "25%" , fontWeight : "bold" }}
                                        className="align-top"
                                      >
                                        Department
                                      </TableCell>
                                      <TableCell
                                        style={{ width: "7%", fontWeight : "bold"  }}
                                        className="align-top text-center"
                                      >
                                        {(isPermissionEdit) &&
                                          <>
                                            Priority
                                          </>
                                        }
                                      </TableCell>
                                      <TableCell style={{ width: "10%" , fontWeight : "bold" }} />
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {(listpod_getcount.length === 0 && (
                                    <TableRow key={1}>
                                      <TableCell colSpan={4} align="center">
                                        {ConfigETC.NoData}
                                      </TableCell>
                                    </TableRow>
                                  )) ||
                                  (listpod_getcount
                                    .slice(
                                      pagepod * rowsPerPagepod,
                                      pagepod * rowsPerPagepod + rowsPerPagepod
                                    )
                                    .map((row) => (
                                      <Fragment key={row.rowindex}>
                                        {editDeptSettingId === row.pro_dept_id ? (
                                          <DeptSettingEdittableRow
                                            listpod_getcount={editFormData}
                                            row={row}
                                            OnclickSave_ModeldepartmentAE={OnclickSave_ModeldepartmentAE}
                                            OnclickCancel_ModeldepartmentAE={OnclickCancel_ModeldepartmentAE}
                                            isPermissionEdit={isPermissionEdit}
                                            isPermissionDel={isPermissionDel}
                                          />
                                        ) : (
                                          <DeptSettingView
                                            listpod_getcount={listpod_getcount}
                                            row={row}
                                            onclick_PODSorting={onclick_PODSorting}
                                            onclick_PODEdit ={onclick_PODEdit}
                                            onclick_PODDel={onclick_PODDel}
                                            isPermissionEdit={isPermissionEdit}
                                            isPermissionDel={isPermissionDel}
                                          />
                                        )}

                                  </Fragment>
                                  )))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                            {listpod_getcount.length > 0 && (
                              <TablePagination
                                rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                                component="div"
                                count={listpod_getcount.length}
                                rowsPerPage={rowsPerPagepod}
                                page={pagepod}
                                onPageChange={handleChangePagepod}
                                onRowsPerPageChange={handleChangeRowsPerPagepod}
                                ActionsComponent={PaginationActions}
                              />
                            )}
                          </div>
            {/* ########################### Project Organization Department Get list ########################### */}
              
                
               
                
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      {/* ########################### Pop up Pro Department Setting ########################### */}

      {/* ########################### Pop up Pro Staff and Position Add ########################### */}
      <div className="modal fade" id="modal-staff-add">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <i className="fas fa-plus"></i>   Add Staff and Position
              </h4>
              <button
                type="button"
                id="modalStaffAdd_Close"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-horizontal">
                <div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-3 col-form-label">
                          Staff <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-9">
                        {/* <select id="ddl_box2s_staff" className="form-control form-control-sm">
                            <option value="-1" >{ConfigETC.ddl_pleaseselect}</option>
                            {listddl_staff.length > 0 &&
                            listddl_staff.map((en) => 
                              <option key={en.staff_code} value={en.staff_code} >
                                {en.fullname}
                              </option>
                              )
                            }
                          </select> */}
                          {isLoadedConfigData && 
                              <SelectStaffForPos
                                refid={selectRef_Staff}
                                API_URL={configData.API_URL}
                                project_id={pgProid.toString()}
                                selectismulti={true}
                                SelectTextDefault={ConfigETC.ddl_pleaseselect}
                                resetSelect={iscntreset}
                                reBindSelect={iscntrebind}
                                onChangevalue={OnChangevalueStaff}
                                iscloseMenuOnSelect={false}
                              ></SelectStaffForPos> 
                              }
                          </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-3 col-form-label">
                          Position <span className="text-danger">*</span>
                        </label>
                          <div className="col-sm-9">
                            <select id="ddl_box2s_positionstaff" className="form-control form-control-sm" 
                                onChange={onchange_ddl_box2s_positionstaff} 
                                >
                              <option value="-1" >{ConfigETC.ddl_pleaseselect}</option>
                              {listddl_positiondept.length > 0 &&
                              listddl_positiondept.map((en , index) => (
                                // <option key={index} value={en.pro_pos_id + "|" + en.type} >
                                //   {en.position_name}
                                // </option>
                                <React.Fragment key={index}>
                                    <option value={en.pro_pos_id + "|" + en.type}>
                                        {en.position_name}
                                    </option>
                                    {index !== listddl_positiondept.length - 1 && (
                                          <React.Fragment>
                                              {/* Check if en.type changes */}
                                              {en.type !== listddl_positiondept[index + 1].type && (
                                                  <option disabled="disabled">-----------------------------</option>
                                              )}
                                          </React.Fragment>
                                      )}
                                </React.Fragment>
                                  )
                                )
                              }
                              {ismorepositionshow === true &&
                                <option value="-99" >{ConfigETC.ddl_moreposition}</option>
                              }
                            </select>
                        </div>
                      </div>
                     
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
              {(isPermissionEdit) &&
                <a
                  href="#!"
                  data-toggle="pill"
                  onClick={onclick_POS_SaveAdd}
                  className="btn btn-primary"
                  title="Add"
                >
                  <i className="fas fa-plus" />{" "}
                  Add
                </a>
              }
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      {/* ########################### Pop up Pro Staff and Position Add ########################### */}


      {/* ########################### Pop up Copy Project Org  ########################### */}
        <button id="btn_copy_project"
            className="btn btn-primary btn-xs d-none"
            title="Copy Project Organization"
            data-backdrop="static"
            data-keyboard="false" 
            data-target="#modal-copy-project"
            data-toggle="modal"
            >
        </button>
        <input type="hidden" id="hd_isModal" ></input>
      <div ref={modalRef} className="modal fade" id="modal-copy-project" tabIndex={-1} role="dialog">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <i className="fas fa-copy"></i>  Copy Project Organization
              </h4>
              <button
                type="button"
                id="modalCopyProject_Close"
                className="close d-none"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">   
              <div className="form-horizontal">
                <div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-3 col-form-label">
                          Project <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-9">
                          {isLoadedConfigData && 
                              <SelectProject
                                refid={selectRef_PorjectOrg}
                                API_URL={configData.API_URL}
                                pro_status={'-1'}
                                selectismulti={false}
                                SelectTextDefault={ConfigETC.ddl_pleaseselect}
                                resetSelect={iscntreset}
                                onChangevalue={OnChangevalueProjectOrg}
                                iscloseMenuOnSelect={true}
                              ></SelectProject> 
                              }
                          </div>
                      </div>
                </div>

                <div className="p-0" id="div_listpos">
                    <TableContainer sx={{ maxHeight: 650 }}>
                        <Table stickyHeader aria-label="sticky table" className="table table-head-fixed table-hover text-sm table-fit" style={{marginBottom:0}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell width={"2%"} align={"left"} className="align-top"><b>#</b></TableCell>
                                    <TableCell width={"20%"} align={"left"} className="align-top"><b>Department</b></TableCell>
                                    <TableCell width={"20%"} align={"left"} className="align-top"><b>Position </b></TableCell>
                                    <TableCell width={"15%"} align={"center"} className="align-top"><b>Staff </b></TableCell>
                                </TableRow>
                               
                            </TableHead>
                            <TableBody >
                                {(listcopypos.length === 0 && (
                                    <TableRow key={1}>
                                    <TableCell colSpan={4} align="center">
                                        {ConfigETC.NoData}
                                    </TableCell>
                                    </TableRow>
                                )) ||
                                listcopypos.map((row,index) => {
                                  const isFirstRowOrDifferentDept = index === 0 || row.dept_name !== listcopypos[index - 1].dept_name;
                                  let rownumber = 1; // เริ่มต้นที่ 1 สำหรับแต่ละแผนก
                                  if (isFirstRowOrDifferentDept) {
                                    rownumber = deptCount; // เพิ่มตามลำดับของแผนก
                                    deptCount++;
                                  }
                                  return  (
                                    <TableRow key={row.rowindex}>
                                        <TableCell>
                                            <div>
                                              {isFirstRowOrDifferentDept ? rownumber : ''}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div>
                                              {isFirstRowOrDifferentDept ? row.dept_name : ''}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div>
                                              {row.position_name}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className="text-center"> 
                                            {row.count_staff}
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    )}
                                    )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>


              </div>
            </div>
            <div className="modal-footer justify-content-between">
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={onclick_CancelCopyProjectOrg}
                    title="Cancel"
                    // data-dismiss="modal"
                  >
                    <i className="fa fa-times" /> Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary float-right"
                    onClick={onclick_SaveCopyProjectOrg}
                    title="Save"
                  >
                    <i className="fas fa-save" /> Save
                  </button>
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      {/* ########################### Pop up Copy Project Org ########################### */}





    </>
  );
}

export default M_project_ae;
